const faNums = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
const faDigitsRegex = /[۰۱۲۳۴۵۶۷۸۹]/g;

const cachedNumberFormatterInstances = {
  [`en-US-${JSON.stringify({})}`]: new Intl.NumberFormat('en-US', {}),
};

function numberFormatter(number: number, locale = 'en-US', configs = {}) {
  const instanceKey = `${locale}-${JSON.stringify(configs)}`;
  let formatterInstance = cachedNumberFormatterInstances[instanceKey];

  if (!formatterInstance) {
    const newInstance = new Intl.NumberFormat(locale, configs);

    cachedNumberFormatterInstances[instanceKey] = newInstance;
    formatterInstance = newInstance;
  }

  return formatterInstance.format(number);
}

const convertFaDigitsToEn = (value: string) => {
  return String(value).replace(
    faDigitsRegex,
    (char) => `${faNums.indexOf(char)}`
  );
};

export { numberFormatter, convertFaDigitsToEn };
